export const filterRelativeLinks = (link: string, market: string) => {
  return (
    "/" +
    link
      ?.split("/")
      .filter((e) => e && e !== market)
      .join("/")
      .replace(/\/?$/, "/")
  );
};

export const getHref = () => {
  if (typeof window !== "undefined") return window?.location?.href;
  return "";
};

export const addTrailingSlash = (url: string) => {
  if (url.includes("mailto")) return url; // fix adding trailing when is mailto
  return url?.replace(/\/?$/, "/");
};

export const classNames = (...items: any) =>
  items.filter((a: any) => a).join(" ");
